module.exports = __webpack_public_path__ + "static/media/girl_bra.1bdf4d9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/brand/girl_bra.png
// module id = 153
// module chunks = 0